module.exports = __webpack_public_path__ + "static/media/totalPnts_250_500.1840b266.png";